import React, { FC, PropsWithChildren, createContext, useContext, useMemo, useState } from 'react';

import { StoreLocatorServiceModeTab } from '@fhs/store-locator';
import { useServiceModeContext } from 'state/service-mode';
import { OrderLocatorTab } from 'utils/launchdarkly/variations';

import useSearchRestaurants from '../hooks/use-search-restaurants';
import useStoreLocatorView from '../hooks/use-store-locator-view';

import { IStoreLocatorContext } from './types';

export const StoreLocatorContext = createContext<IStoreLocatorContext>({} as IStoreLocatorContext);

export const useStoreLocatorContext = () => useContext<IStoreLocatorContext>(StoreLocatorContext);

export const StoreLocatorProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}: PropsWithChildren<{}>) => {
  const { ErrorDialog, Dialog } = useSearchRestaurants();
  const { currentView, updateStoreLocatorView, currentViewIsMap } = useStoreLocatorView();
  const { serviceMode } = useServiceModeContext();

  const [selectedRestaurantId, setSelectedRestaurantId] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<OrderLocatorTab>(OrderLocatorTab.NEARBY);
  const [serviceModeTab, setServiceModeTab] = useState<StoreLocatorServiceModeTab>(
    StoreLocatorServiceModeTab.PICKUP
  );

  const value = useMemo(
    () => ({
      ErrorDialog,
      Dialog,
      currentView,
      updateStoreLocatorView,
      serviceMode,
      currentViewIsMap,
      selectedRestaurantId,
      setSelectedRestaurantId,
      activeTab,
      setActiveTab,
      serviceModeTab,
      setServiceModeTab,
    }),
    [
      ErrorDialog,
      Dialog,
      currentView,
      updateStoreLocatorView,
      serviceMode,
      currentViewIsMap,
      selectedRestaurantId,
      activeTab,
      serviceModeTab,
    ]
  );

  return <StoreLocatorContext.Provider value={value}>{children}</StoreLocatorContext.Provider>;
};
